// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Slovenia from '../_raw/flag/icon_flag_slovenia.png';

export default () => <img src={Slovenia} alt="Slovenia" />;
